import React, { useEffect, useState } from 'react';
import { Radar, RadarChart, PolarGrid, Legend, PolarAngleAxis, Tooltip, ResponsiveContainer, PolarRadiusAxis } from 'recharts';
import { colorCodes } from '../../utils/color';

function RadarGraphCombo(props) {

  // Check if custom dimemsions are non-zero
  // const customDim = [];
  // props.data.map((dim,index)=>(
  //   customDim.push(dim.Custom)
  // ));
  // const customDimSum = customDim.reduce((partialSum, a) => partialSum + a, 0);


  const colors = {
    custom: '#8884d8',
    proximity: '#82ca9d',
    reference: '#e31c79',
  }

  const CustomTooltip = ({ active, payload }: any) => {
    // console.log(payload)
    if (active && payload && payload.length) {
      return (
        <div className='bg-white bg-opacity-90 border-gray-200 border-2  px-5 py-3 rounded-sm'>
          <div className='flex-inline'>
            <p className='text-sm font-bold mb-2'>{payload[0].payload.subject}</p>
            <div className='flex-inline text-right'>
              <div className='flex justify-end'>            
                <p className={`font-semibold text-sm text-[${colors.custom}]`}>Custom&#160;</p>
                <p className='text-sm text-[#8884d8]'>: {payload[0].payload.Custom}</p>
              </div>
              {payload[0].dataKey==='Closest' && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#82ca9d]'>Proxmitiy&#160;</p>
                <p className='text-sm text-[#82ca9d]'>({payload[0].name.length<40?
                payload[0].name: payload[0].name.slice(0,38)+'...'}): {payload[0].payload.Closest}</p>
              </div>
              }
              {(payload[1] && payload[1].dataKey==='Closest') && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#82ca9d]'>Proxmitiy&#160;</p>
                <p className='text-sm text-[#82ca9d]'>({payload[1].name.length<40?
                payload[1].name: payload[1].name.slice(0,38)+'...'}): {payload[1].payload.Closest}</p>
              </div>
              }

              {(payload[1] && payload[1].dataKey==='Reference') && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#e31c79]'>Reference&#160;</p>
                <p className='text-sm text-[#e31c79]'>({payload[1].name.length<40?
                payload[1].name: payload[1].name.slice(0,38)+'...'}): {payload[1].payload.Closest}</p>
              </div>
              }
              {payload[2] && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#e31c79]'>Reference&#160;</p>
                <p className='text-sm text-[#e31c79]'>({payload[2].name.length<40?
                payload[2].name: payload[2].name.slice(0,38)+'...'}): {payload[2].payload.Reference}</p>
              </div>
              }
            </div>
          </div>
        </div>
      );
    }
  
    return null;
  };


  const renderColorfulLegendText = (value: string, entry: any) => {
    // const { color } = entry;  
    return <span style={{ color: "#53565a" }} className='text-xs font-semibold'>{value}</span>;
  };


  // const [legendAlign, setLegendAlign] = useState("left");
  const [legendVerticalAlign, setLegendVerticalAlign] = useState("middle");
  useEffect(() => {
    function handleResize() {
      // console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      if (window.innerWidth < 768) {
        // setLegendAlign("center")
        setLegendVerticalAlign("top")
      } else {
        // setLegendAlign("left")
        setLegendVerticalAlign("middle")
      }
    }

    window.addEventListener('resize', handleResize)
  })

  return (
    <div className='flex flex-wrap justify-center gap-x-4'>

      {/* Actual Chart */}
      <div className='w-[250px]'>
        <ResponsiveContainer width="100%" height={250}>
        <RadarChart cx="45%" cy="50%" outerRadius="62%" height="100%" data={props.data}
                    margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <PolarGrid gridType='circle'
                    polarRadius={[0,75]}
                    style = {{ 'stroke':"#bdbfbf", 'strokeWidth': 0.403,
                                'fill':'#FFFFFF', 'fillOpacity': 0.5,}}
                    />
          <PolarAngleAxis dataKey="subject"
                          fontSize={props.labelFontSize ? props.labelFontSize : 16}
                          // style = {{ 'stroke':"#e31c79", 'width': 1,}}
                          />
          <PolarRadiusAxis angle={30} domain={[0, 100]} style={{ opacity: 0}}/>

          {props.dataNames.map((option,index)=>(
            <Radar key={index} name={[option]} dataKey={index} stroke={colorCodes[index]} fill={colorCodes[index]} fillOpacity={0.6}/>
          ))}

          {!props.hideLegend && 
          <Tooltip content={<CustomTooltip payload={props.data} />}
                  position={props.showName.length>=30 && { x: -150 }}
                  //  allowEscapeViewBox={{ x: false, y: true }}
                  // position={{ x: -150 }}
                  //  viewBox={{ x: -100, y: 0, width: 400, height: 400 }}
          />
          }

        </RadarChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      <div className='md:-mr-60 overflow-auto w-full md:w-1/3'>
        <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy={400} outerRadius="100%" height="100%" data={props.data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="subject"
                          fontSize={props.labelFontSize ? props.labelFontSize : 16}
                          // style = {{ 'stroke':"#e31c79", 'width': 1,}}
                          />

          {props.dataNames.map((option,index)=>(
            <Radar key={index} hidden name={[option]} dataKey={index} stroke={colorCodes[index]} fill={colorCodes[index]} fillOpacity={0.6}/>
          ))}

          <Legend layout="vertical"
                  // align={legendAlign}
                  align="center"
                  verticalAlign={legendVerticalAlign}
                  iconSize={12}
                  iconType="square"
                  // wrapperStyle={{
                  //   left: 20,
                  //   top: 0,
                  // }} 
                  // content={renderLegend}
                  formatter={renderColorfulLegendText}
          />

        </RadarChart>
        </ResponsiveContainer>
      </div>

    </div>
  );
}

export default RadarGraphCombo;
